import {getSetting} from '../../../../spine-appkit-vue/src/utils/settings';

class LinkProvider {
    static instance = new this();

    constructor() {
        this.fetchLinksPromise = null;
    }

    /**
     * Get links
     *
     * @returns {Promise<null>}
     */
    async getLinks() {
        // if we already have a promise running we return that to prevent multiple request
        if(this.fetchLinksPromise) {
            return this.fetchLinksPromise;
        }

        this.fetchLinksPromise = this.fetchLinks();
        const result = await this.fetchLinksPromise;
        this.fetchLinksPromise = null;

        return result;
    };

    /**
     * Fetch links
     * Do the fetch request to get the link object
     *
     * @returns {Promise<[]>}
     */
    async fetchLinks() {
        const request = await fetch(getSetting('paths.baseCms') + '/redactor/links');
        return await request.json();
    }
}


RedactorX.add('plugin', 'linkto', {
    /**
     * Init linkto
     */
    init: async function() {
        // We get the known links we can use for redactor
        const links  = await LinkProvider.instance.getLinks();

        if(links.length) {
            // add them to the definedLinks plugins items
            links.forEach(item => {
                this.app.opts.definedlinks.items.push(item)
            })
        }
    },
});